<template>
  <div class="a-loader">

    <div class="a-loader-container">
      <div class="a-loader-logo">
        <img src="/svg/logo_color.svg" alt="VR Capital">
      </div>
    </div>

    <div class="a-loader-indicator">
      <div class="a-loader-progress"></div>
    </div>

  </div>
</template>

<script>
import Loader from './loader';

export default {
  mounted() {
    const loader = new Loader();
    loader.init();
  },
};
</script>
